import { Countries } from '../../../models/countries'
import SIGN_A4 from '../../../assets/img/order_signA4.png'
import SIGN_A5 from '../../../assets/img/order_signA5.png'
import SIGN_SHELF from '../../../assets/img/order_sign_shelf.png'
import STICKER from '../../../assets/img/order_sticker.png'
import STICKER_ENTRANCE from '../../../assets/img/order_sticker_entre.png'
import TAG from '../../../assets/img/order_tag.png'

export const ORDER_TYPE = {
  REPLY_ENVELOPE: 'REPLY_ENVELOPE',
  FOLDER: 'FOLDER',
  CREDIT_APPLICATION: 'CREDIT_APPLICATION',
  PURCHASE_NOTE: 'PURCHASE_NOTE',
  SIGN_A4: 'SIGN_A4',
  SIGN_A5: 'SIGN_A5',
  SIGN_SHELF: 'SIGN_SHELF',
  STICKER: 'STICKER',
  STICKER_ENTRANCE: 'STICKER_ENTRANCE',
  TAG: 'TAG',
}

export const ORDER_KEY = {
  REPLY_ENVELOPE: 'replyEnvelope',
  FOLDER: 'folder',
  CREDIT_APPLICATION: 'creditApplication',
  PURCHASE_NOTE: 'purchaseNote',
  SIGN_A4: 'signA4',
  SIGN_A5: 'signA5',
  SIGN_SHELF: 'signShelf',
  STICKER: 'sticker',
  STICKER_ENTRANCE: 'stickerEntrance',
  TAG: 'tag',
}

export const ORDER_COUNTRY_DISABLED = {
  REPLY_ENVELOPE: [Countries.DK],
  CREDIT_APPLICATION: [Countries.DK],
  PURCHASE_NOTE: [Countries.DK],
  SIGN_A4: [Countries.SE, Countries.DK, Countries.NO],
}

export const ORDER_ALLOWED_QUANTITY = {
  REPLY_ENVELOPE: [],
  FOLDER: [50, 100, 150, 200, 250, 300],
  SIGN_A4: [1, 2, 3],
  SIGN_A5: [1, 2, 3],
  SIGN_SHELF: [1, 2, 3],
  STICKER: [1, 2, 3],
  STICKER_ENTRANCE: [1, 2],
  TAG: [1, 2, 3],
}

export const ORDER_DESCRIPTION = {
  REPLY_ENVELOPE: 'Reply envelope',
  FOLDER: 'Folder',
  SIGN_A4: 'Sign A4',
  SIGN_A5: 'Sign A5',
  SIGN_SHELF: 'Sign shelf 80x80',
  STICKER: 'Sticker 20x70',
  STICKER_ENTRANCE: 'Sticker entrance 75x45',
  TAG: 'Tag',
}

export const ORDER_IMAGE = {
  SIGN_A4,
  SIGN_A5,
  SIGN_SHELF,
  STICKER,
  STICKER_ENTRANCE,
  TAG,
}
